import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-post-modern-exchange-fee-daily',
  templateUrl: './post-modern-exchange-fee-daily.component.html',
  styleUrls: ['./post-modern-exchange-fee-daily.component.css']
})
export class PostModernExchangeFeeDailyComponent implements OnInit {

  constructor(private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { 

  }
 
  SearchModel = {
    CreditAccID: 0,
    DebitAccID: 0,
    CancelStatus: 'N',
    Amount: 0,
    ClassID: 0,
    SectionID: 0,
    PaymentMode: 0,
    FromDate: '',
    ToDate: '',
    Narration: '',
    CounterTypeID: 0,
    TransDate: moment(new Date()).format('DD-MMM-YYYY'),
};

CurrencyModel = {
    R2000: 0,
    R500: 0,
    R200: 0,
    R100: 0,
    R50: 0,
    R20: 0,
    R10: 0,
    R5: 0,
    R2: 0,
    R1: 0,   
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    IsActive: true,
    Remarks: '',

}
isLock = false;
ExternalUserAccList:any;
GetExternalUserAcc  () {
   this.lookupService.GetLookupsList('ExternalUserAcc', '').subscribe( (data)=> {
        this.ExternalUserAccList = data.LookupItems;
        if (this.ExternalUserAccList.length > 1) {
            for (var i = 0; i < this.ExternalUserAccList.length; i++) {
                if (this.ExternalUserAccList[i].AccID > 0) {
                    this.isLock = true;
                }

            }

        }
    });
};
Submitted = false;
PostFeeDailyList=[];
GetPostModernExchangeFeeDaily  () {
    this.Submitted = true;
    this.SearchModel.Narration='';
    if (!this.ValidateDropdownSearch()) {
      this.SearchModel.FromDate=moment(this.SearchModel.FromDate).format('DD-MMM-YYYY');
       this.spinnerService.show();
        this.accService.GetPostModernExchangeFeeDaily(JSON.stringify(this.SearchModel)).subscribe( (response)=> {
          this.spinnerService.hide();
            this.UserComponetLIst = response.UserComponetLIst;
            this.PostFeeDailyList = response.PostFeeDailyList;
            if (this.UserComponetLIst != null && this.UserComponetLIst.length > 0) {
                for(var i=0;i<this.UserComponetLIst.length;i++){
                    this.UserComponetLIst[i].Amount=this.UserComponetLIst[i].R1*1+this.UserComponetLIst[i].R2*2+this.UserComponetLIst[i].R5*5+this.UserComponetLIst[i].R10*10+this.UserComponetLIst[i].R20*20+this.UserComponetLIst[i].R50*50+this.UserComponetLIst[i].R100*.100+this.UserComponetLIst[i].R200*200+this.UserComponetLIst[i].R500*500+this.UserComponetLIst[i].R2000*2000;
                }
                this.SearchModel.Narration = this.UserComponetLIst[0].Narration;
            }
           
           
        });

    }
}
 ValidateDropdownSearch() {
    return this.SearchModel.FromDate == ''


};
AmountAlert = true;
UserComponetLIst:any;
 ValidateAmount() {
    this.AmountAlert = true;
    if (this.SearchModel.CounterTypeID != 2) {
        for (var i = 0; i < this.UserComponetLIst.length; i++) {
            this.UserComponetLIst[i].Amount=this.UserComponetLIst[i].R1*1+this.UserComponetLIst[i].R2*2+this.UserComponetLIst[i].R5*5+this.UserComponetLIst[i].R10*10+this.UserComponetLIst[i].R20*20+this.UserComponetLIst[i].R50*50+this.UserComponetLIst[i].R100*.100+this.UserComponetLIst[i].R200*200+this.UserComponetLIst[i].R500*500+this.UserComponetLIst[i].R2000*2000;
            if (this.UserComponetLIst[i].CashAmount != this.UserComponetLIst[i].Amount) {
                this.AmountAlert = false;
            }

        }
    }
    return this.AmountAlert;


}
SelectAlertMsg = '';

SubmittedSave = false;

SavePostModernExchangeFeeDaily  () {
  this.SearchModel.FromDate=moment(this.SearchModel.FromDate).format('DD-MMM-YYYY');
    this.SubmittedSave = true;
    if (!this.ValidateDropdownSave() && this.ValidateAmount()) {
        var result = true;

        if (result) {

            this.SelectAlertMsg = '';
           
            this.spinnerService.show();
            this.accService.SavePostModernExchangeFeeDaily(JSON.stringify(this.SearchModel), JSON.stringify(this.PostFeeDailyList), JSON.stringify(this.UserComponetLIst)).subscribe( (response)=> {
              this.spinnerService.hide();
              
                this.SubmittedSave = false;
                this.GetPostModernExchangeFeeDaily();
                this.globalHelper.CheckActionStatus(response);

            });
        }

    }

}

 ValidateDropdownSave() {
    return this.SearchModel.Narration == ''


};
VoucherTypeList:any;
GetVoucherType  () {
   this.lookupService.GetLookupsList('VoucherType', '').subscribe( (data)=> {

        this.VoucherTypeList = data.LookupItems;
    });

};

// ChangeVoucherType  () {

//     for (var i = 0; i < this.VoucherTypeList.length; i++) {
//         if (this.VoucherTypeList[i].ItemCode1 == this.VoucherType) {
//             var url = this.BranchDetails.AppPath + "Home/Index/#/" + this.VoucherTypeList[i].PageUrl + "?VoucherType=" + this.VoucherTypeList[i].ItemCode1
//             window.location = url;
//         }
//     }




//}






  ngOnInit() {
    this.GetExternalUserAcc();
  }

}
